<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>流向凭据</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="code" placeholder="请输入代码" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.status">
                <el-select v-model="status" placeholder="请选择凭据状态" clearable>
                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.source_account_rid">
                <el-select
                    v-model="source_account_name"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入源账户搜索"
                    :remote-method="remoteMethod"
                    :loading="parentLoading"
                    clearable
                    value-key="rid"
                    @change="sourceChange"
                >
                    <el-option v-for="item in parentOptions" :key="item.rid" :label="item.name" :value="item"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.web_code">
                <el-input v-model="web_code" placeholder="请输入网站代码" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.remark">
                <el-input v-model="remark" placeholder="请输入备注" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.parameter">
                <el-input v-model="parameter" placeholder="请输入参数" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.data_composition">
                <el-input v-model="data_composition" placeholder="请输入数据构成" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.username">
                <el-input v-model="username" placeholder="请输入用户名" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.url">
                <el-input v-model="url" placeholder="请输入URL" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.province_rid">
                <el-select filterable v-model="province_rid" placeholder="请选择省份" clearable>
                    <el-option v-for="item in provincesOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="main_header_item" >
                <el-select v-model="person_rid" placeholder="请选择人员" clearable filterable>
                    <el-option v-for="item in personOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.description">
                <el-input v-model="description" placeholder="请输入说明" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增流向凭据</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload v-if="postList.uploadBtn" obj="commodity_flow_source_credential"></crm-upload>
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="commodity_flow_source_credential"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="item.prop == 'code' || item.prop == 'source_account_name' || item.prop == 'url'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else-if="item.prop == 'status_label'">
                                <span v-if="scope.row.status == 1" style="color: red">{{ scope.row.status_label }}</span>
                                <span v-else-if="scope.row.status == 2" style="color: green">{{ scope.row.status_label }}</span>
                                <span v-else-if="scope.row.status == 3" style="color: orange">{{ scope.row.status_label }}</span>
                                <span v-else style="color: purple">{{ scope.row.status_label }}</span>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import draggableList from '../../../../common/Drawer.vue';
import { onReSize, in_array } from '../../../../../js/common';
import crmUpload from '../../../../common/Upload.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'flowVoucherComponent',
    data() {
        return {
            draggable: {
                data_name: 'commodity_flow_source_credential'
            },
            down_loading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            code: '', //code
            source_account_rid: '',
            source_account_name: '',
            web_code: '',
            remark: '',
            parameter: '',
            data_composition: '',
            username: '',
            url: '',
            description: '',
            status: '',
            parentOptions: [],
            statusOptions: [],
            parentLoading: false,
            provincesOptions: [], //省份列表
            province_rid: '',
            personOptions: [],
            person_rid: ''
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        let roles = JSON.parse(localStorage.getItem('roles'));
        if (roles != null && in_array(process.env.VUE_APP_TL_ROLE_ID, roles)) {
            this.postList.downFileBtn = false;
            this.postList.uploadBtn = false;
        }

        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['flowVoucher_params']) {
                this.page = paramsList['flowVoucher_params'].page;
                this.row = paramsList['flowVoucher_params'].row;
                this.source_account_rid = paramsList['flowVoucher_params'].source_account_rid;
                this.source_account_name = paramsList['flowVoucher_params'].source_account_name;
                // this.data_name = paramsList['flowVoucher_params'].data_name;
                // this.sort = paramsList['flowVoucher_params'].sort;
                this.web_code = paramsList['flowVoucher_params'].web_code;
                this.remark = paramsList['flowVoucher_params'].remark;
                this.parameter = paramsList['flowVoucher_params'].parameter;
                this.data_composition = paramsList['flowVoucher_params'].data_composition;
                this.username = paramsList['flowVoucher_params'].username;
                this.url = paramsList['flowVoucher_params'].url;
                this.description = paramsList['flowVoucher_params'].description;
                this.status = paramsList['flowVoucher_params'].status;
                this.code = paramsList['flowVoucher_params'].code;
                this.province_rid = paramsList['flowVoucher_params'].province_rid;
                this.person_rid = paramsList['flowVoucher_params'].person_rid;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getProvinces(); //获取省份
            this.getAdminDropDown();
            this.getStatus();
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //获取省份
        getProvinces() {
            let params = {
                has_all: '0'
            };
            this.$api
                .provinces(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.provincesOptions = [];
                        let data = res.data;
                        data.forEach((value, index) => {
                            this.provincesOptions.push({
                                value: value.rid,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {});
        },
        //获取人员下拉
        getAdminDropDown() {
            let params = {};
            this.$api
                .dropdownPerson(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.personOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('commodity_flow_source_credential', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).commodity_flow_source_credential;
        },
        //获取凭据状态
        getStatus() {
            let params = {};
            this.$api
                .dropdownCredentialStatus(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.statusOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //账户名称远程搜索方法
        remoteMethod(query) {
            if (query !== '') {
                this.parentLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            setTimeout(() => {
                                this.parentLoading = false;
                                this.parentOptions = res.data;
                            }, 200);
                        } else {
                            this.parentOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.parentLoading = false;
                this.parentOptions = [];
            }
        },
        //前往编辑页面
        editDetails(id) {
            this.$router.push({
                path: 'flowVoucherEdit',
                query: {
                    type: 1,
                    id: id
                }
            });
        },
        //复制页面
        copy(id) {
            this.$router.push({
                path: 'flowVoucherEdit',
                query: {
                    type: 5,
                    id: id
                }
            });
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$api
                        .commodityFlowSourceCredentialDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['flowVoucher_params']) {
                    newParamsList['flowVoucher_params'].data_name = val.prop;
                    newParamsList['flowVoucher_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //新增
        addAcount() {
            this.$router.push({
                path: 'flowVoucherEdit',
                query: {
                    type: 3
                }
            });
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'code') {
                this.$router.push({
                    path: '/flowVoucherDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'source_account_name') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.source_account_rid
                    }
                });
            } else if (prop == 'url') {
                window.open(row.url);
            }
        },
        //源账户搜索改变事件
        sourceChange(value) {
            if (value.name) {
                this.source_account_name = value.name;
                this.source_account_rid = value.rid;
            } else {
                this.source_account_name = '';
                this.source_account_rid = '';
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                source_account_rid: this.source_account_rid,
                source_account_name: this.source_account_name,
                web_code: this.web_code,
                remark: this.remark,
                parameter: this.parameter,
                data_composition: this.data_composition,
                username: this.username,
                url: this.url,
                description: this.description,
                status: this.status,
                sort: [this.data_name, this.sort],
                code: this.code,
                is_export: type_data,
                province_rid: this.province_rid,
                person_rid: this.person_rid
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['flowVoucher_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .commodityFlowSourceCredentialLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['flowVoucher_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .commodityFlowSourceCredentialDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['flowVoucher_params']) {
                    newParamsList['flowVoucher_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        source_account_rid: this.source_account_rid,
                        source_account_name: this.source_account_name,
                        web_code: this.web_code,
                        remark: this.remark,
                        parameter: this.parameter,
                        data_composition: this.data_composition,
                        username: this.username,
                        url: this.url,
                        description: this.description,
                        status: this.status,
                        sort: [this.data_name, this.sort],
                        code: this.code,
                        province_rid: this.province_rid,
                        person_rid: this.person_rid
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['flowVoucher_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['flowVoucher_params']) {
                    newParamsList['flowVoucher_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        source_account_rid: this.source_account_rid,
                        source_account_name: this.source_account_name,
                        web_code: this.web_code,
                        remark: this.remark,
                        parameter: this.parameter,
                        data_composition: this.data_composition,
                        username: this.username,
                        url: this.url,
                        description: this.description,
                        status: this.status,
                        sort: [this.data_name, this.sort],
                        code: this.code
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['flowVoucher_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.code = '';
            this.source_account_rid = '';
            this.source_account_name = '';
            this.web_code = '';
            this.remark = '';
            this.parameter = '';
            this.data_composition = '';
            this.username = '';
            this.url = '';
            this.description = '';
            this.status = '';
            this.sort = '';
            this.data_name = '';
            this.page = 1;
            this.row = 25;
            this.province_rid = '';
            this.person_rid = '';
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                code: '',
                source_account_rid: '',
                source_account_name: '',
                web_code: '',
                remark: '',
                parameter: '',
                data_composition: '',
                username: '',
                url: '',
                description: '',
                status: '',
                province_rid: '',
                person_rid: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['flowVoucher_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>